import React from 'react';
import {Typography,} from '@mui/material';
import {useLocation} from 'react-router-dom';
import theme from '../../../theme';
import {InfoText} from '../styles';
import {useTranslation} from 'react-i18next';

interface StateType {
    email: string;
}

export default function SignupSuccess() {
    const { t } = useTranslation();
    const location = useLocation();
    const state: StateType | null = location.state as StateType;

    return state?.email ? (
        <InfoText>
            <Typography variant="body1" sx={{
                [theme.breakpoints.down('md')]: {fontSize: '1.75rem'},
                textAlign: 'center'
            }}>
                {`${t('signup_success_1')} `} <b>{state.email}</b>{t('signup_success_2')}
            </Typography>
        </InfoText>
    ) : (<></>);
}
